<template>
  <div class="list_index">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="实时告警" name="first">
        <el-table stripe border :data="tableData">
          <el-table-column label="设备编号" prop="factoryNo" width="250px" align="center"></el-table-column>
          <el-table-column label="项目编号" prop="itemNo" width="160px" align="center"></el-table-column>
          <el-table-column label="机型" prop="model" width="130px" align="center"></el-table-column>
          <el-table-column label="客户" prop="customer" width="250px" align="center"></el-table-column>
          <el-table-column label="告警类型" prop="alarmType" width="160px" align="center">
            <template slot-scope="scope">
              <p :class="scope.row.alarmType == '状态指示'?'green':
                  scope.row.alarmType == '异常信息'?'orange':
                  scope.row.alarmType == '报警信息'?'yellow':
                  'red'">{{scope.row.alarmType}}</p>
            </template>
          </el-table-column>
          <el-table-column label="报警描述" prop="alarmDescription" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="状态" prop="alarm_status" width="180px" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.alarmStatus == '1' ? '已触发' : '已恢复'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="date" width="250px" align="center"></el-table-column>
          <el-table-column label="Debug" width="100px" align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="明细" placement="top">
                <el-button type="text" icon="el-icon-tickets" @click="showDetail(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-size="size"
            :total="count"
            @current-change="changePage"
            @size-change="handleSizeChange"
            popper-class='select_bottom'
          ></el-pagination>
        </div>
        <el-dialog title="明细" :visible.sync="showAlarmDetail" width="30%">
          <el-row gutter="10">
            <el-col :span="7" class="tr">变量地址：</el-col>
            <el-col :span="17">{{ alarmDetailForm.deviceVariables }}</el-col>
            <el-col :span="7" class="tr">10进制数值：</el-col>
            <el-col :span="17">{{ alarmDetailForm.value }}</el-col>
            <el-col :span="7" class="tr">2进制数值：</el-col>
            <el-col :span="17">{{ alarmDetailForm.binarySystem }}</el-col>
            <el-col :span="7" class="tr">报警内容：</el-col>
            <el-col :span="17">{{ alarmDetailForm.alarmDescription }}</el-col>
          </el-row>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="历史告警" name="second">
        <el-date-picker
          v-model="date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-select v-model="alarm_type" class="m20">
          <el-option class="orange" label="异常信息" value="异常信息"></el-option>
          <el-option class="yellow" label="报警信息" value="报警信息"></el-option>
          <el-option class="red" label="故障信息" value="故障信息"></el-option>
          <el-option label="所有" value=""></el-option>
        </el-select>
        <el-button type="primary" @click="getHistoryAlarmData" class="yl-button m20">查询</el-button>
        <el-table stripe border :data="historyTableData">
          <el-table-column label="设备编号" prop="factoryNo" width="250px" align="center"></el-table-column>
          <el-table-column label="项目编号" prop="itemNo" width="160px" align="center"></el-table-column>
          <el-table-column label="机型" prop="model" width="130px" align="center"></el-table-column>
          <el-table-column label="客户" prop="customer" width="250px" align="center"></el-table-column>
          <el-table-column label="告警类型" prop="alarmType" width="160px" align="center">
            <template slot-scope="scope">
              <p :class="scope.row.alarmType == '状态指示'?'green':
                  scope.row.alarmType == '异常信息'?'orange':
                  scope.row.alarmType == '报警信息'?'yellow':'red'">{{scope.row.alarmType}}</p>
            </template>
          </el-table-column>
          <el-table-column label="报警描述" prop="alarmDescription" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="状态" prop="alarm_status" width="180px" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.alarmStatus == '1' ? '已触发' : '已恢复'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="date" width="250px" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="historyPage"
            :page-size="historySize"
            :total="historyCount"
            @current-change="historyChangePage"
            @size-change="historyHandleSizeChange"
            popper-class='select_bottom'
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DataService from '../../api/data'
import { utils } from "@/utils/index.js";
export default {
  data(){
    return{
      showAlarmDetail:false,//告警明细窗口
      // onlineOnOffline:'all',//on是已触发，off是已恢复，all是所有
      page: 1,
      historyPage:1,
      count: 0,
      historyCount:0,
      size:10,
      historySize:10,
      noticeStatus:'1',
      tableData:[],
      historyTableData:[],
      activeName: 'first',
      date:[],
      user_id:'',
      alarm_type:'',
      alarmDetailForm:{}
    }
  },
  methods:{
    showDetail(val){
      this.showAlarmDetail = true;
      this.alarmDetailForm = val;
    },
    //获取全部告警数据
    getAlarmData(){
      DataService.getAlarmDataAll({ 
        user_id:this.user_id,
        status:1,
        page:this.page,
        size:this.size,
        user_token:this.$store.state.token
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    //获取历史告警数据
    getHistoryAlarmData(){
      DataService.getHistoryAlarmData({
        user_id:this.user_id,
        status:1,
        // onlineOnOffline:this.onlineOnOffline,
        page:this.historyPage,
        size:this.historySize,
        startTime:this.date[0],
        endTime:this.date[1],
        alarm_type:this.alarm_type,
        user_token:this.$store.state.token
      }).then(res=>{
        this.historyTableData = res.data.projectSiteList;
        this.historyCount = res.data.count;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    //获取最新时间
    showTime() {
      const endTime = utils.formatDate(new Date(new Date().getTime()));
      const startTime = utils.formatDate(new Date(new Date().getTime() - 24*3600*1000));
      this.date = [startTime,endTime];
    },
    handleClick(){
      if(this.activeName == 'first'){
        this.getAlarmData()
      }else{
        this.getHistoryAlarmData()
      }
    },
    changePage(page) {
      this.page = page;
      this.getAlarmData()
    },
    handleSizeChange(val){
      this.size = val;
      this.getAlarmData()
    },
    historyChangePage(page){
      this.historyPage = page;
      this.getHistoryAlarmData()
    },
    historyHandleSizeChange(val){
      this.historySize = val;
      this.getHistoryAlarmData()
    }
  },
  mounted(){
    this.showTime()
    this.getAlarmData()
    this.getHistoryAlarmData()
  },
  created(){
    if(this.$route.query.user_id){
      this.$emit('pc',0) 
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('mobi') !=-1) { 
    // 手机浏览器 
      this.user_id = window.sessionStorage.getItem('user_id')
    } else { 
      // 非手机浏览器 
      this.user_id = this.$store.state.user_id
    }
  }
}
</script>

<style lang="scss" scoped>
.green{
  color: greenyellow;
}
.orange{
  color: orange;
}
.yellow{
  color: yellow;
}
.red{
  color: red;
}
.el-row{
  font-size: 20px;
  color: #fff;
  line-height: 40px;
}
.tr{
  text-align: right;
  font-weight: 600;
}
</style>